function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 23.006,
  y: 56,
  width: 19,
  height: 6
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.707107,-0.707107,0.707107,0.707107,-4.73979,10.4322)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.723,
  y: 8.438,
  width: 19,
  height: 5
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.707107,-0.707107,0.707107,0.707107,8.19277,41.3932)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 51.562,
  y: 1.307,
  width: 5,
  height: 19
}));

var SvgHands = function SvgHands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-69,-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hands",
    transform: "matrix(1.61997,0,0,1.61997,-45.6389,125.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.578715,0,0,0.578715,70.9114,9.37552)"
  }, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "M44.556,9.707L41.865,9.593C40.293,9.371 38.705,9.901 37.582,11.024L32.077,16.529L26.324,10.775C25.307,9.782 23.819,9.431 22.466,9.866C21.19,10.254 19.798,9.906 18.855,8.963L18.001,8.109L7.394,18.716L9.122,20.444L9.008,23.135C8.786,24.707 9.317,26.295 10.44,27.418L20.052,37.031C20.181,35.769 20.786,34.603 21.743,33.772L18.748,30.777L19.455,30.07L22.584,33.198C23.027,32.945 23.507,32.763 24.006,32.657L24.006,28.963L22.284,27.241L22.991,26.534L24.006,27.549L24.006,22.199C23.983,20.378 25.342,18.81 27.148,18.574C27.479,18.542 27.813,18.557 28.139,18.619L26.91,17.39L27.617,16.682L29.413,18.479C30.062,17.221 31.405,16.468 32.816,16.57C34.532,16.771 35.874,18.179 35.991,19.902C36.559,19.632 37.189,19.518 37.816,19.57C39.653,19.79 41.041,21.384 41.006,23.233L41.006,26.657C42.859,27.044 44.34,28.451 44.822,30.282L47.61,27.494L48.318,28.201L45.002,31.516C45.002,31.53 45.006,31.543 45.006,31.557L45.006,34.877C45.904,34.783 46.744,34.384 47.385,33.748L54.225,26.908C55.218,25.892 55.569,24.403 55.134,23.05C54.746,21.774 55.094,20.382 56.037,19.439L56.891,18.585L46.284,7.979L44.556,9.707Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88,21.69C29.723,20.346 28.5,19.364 27.155,19.501C25.854,19.68 24.884,20.818 24.912,22.13L24.912,33.488C22.718,33.488 20.912,35.294 20.912,37.488L20.912,47.161C20.929,48.582 21.733,49.883 22.998,50.532C24.175,51.16 24.912,52.39 24.912,53.724L24.912,54.932L39.912,54.932L39.912,52.488L41.896,50.665C43.165,49.711 43.912,48.212 43.912,46.624L43.912,31.488C43.912,29.294 42.107,27.488 39.912,27.488L39.912,23.165C39.947,21.832 38.959,20.673 37.636,20.498C36.336,20.383 35.155,21.307 34.954,22.597L35.412,22.597L35.412,38.04L34.412,38.04L34.412,22.597L34.912,22.597L34.912,20.165C34.947,18.832 33.959,17.673 32.636,17.498C32.562,17.491 32.487,17.488 32.413,17.488C31.041,17.488 29.912,18.616 29.912,19.988L29.912,21.69L30.412,21.69L30.412,37.133L29.412,37.133L29.412,21.69L29.88,21.69ZM25.312,42.04L24.312,42.04L24.312,34.04L25.312,34.04L25.312,42.04ZM39.412,27.798L40.412,27.798L40.412,38.242L39.412,38.242L39.412,27.798Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hands.b8f81974.svg";
export { ForwardRef as ReactComponent };